module.exports = __webpack_public_path__ + "img/negativeCard.c000a5f1.png";